import BlankProfile from './Images/blank-profile.png';
import DnbLogo from './Images/logo.webp';

export const Blank_Profile = BlankProfile;
export const Dnb_Logo = DnbLogo;